import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate, Outlet } from 'react-router-dom';
import PanicReport from "./Panic-report/PanicReport";
import PanicAlertDetail from "./Panic-report/PanicAlertDetail";
import RouteWrapper from '../../../routing/RouterWrapper';

const AlertsWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/alerts') {
      navigate('panic-alerts');
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      <Route path="/" element={<WrapperWithOutlet />}>
        <Route path="panic-alerts" element={<RouteWrapper component={PanicReport} />} />
        <Route path="panic-alerts/:vehicleId" element={<RouteWrapper component={PanicAlertDetail} />} />
      </Route>
    </Routes>
  );
};

const WrapperWithOutlet = () => {
  return <Outlet />;
};

export default AlertsWrapper;
